import { DEFAULT_LOCALE, isSupportedLocale, type Locale } from "./locales";

/**
 * Browser tags that mean one of ours but spell it differently. Browsers report
 * Malay as ms / ms-MY / ms-BN / ms-SG — the platform code is "bm". Old devices
 * still report Filipino as Tagalog "tl".
 */
const ALIASES: Record<string, Locale> = {
	ms: "bm",
	tl: "fil",
};

/** First supported language from the browser's preference list; en otherwise. */
export function detectLocale(languages: readonly string[] = navigator.languages): Locale {
	for (const tag of languages) {
		const base = tag.toLowerCase().split("-")[0] ?? "";
		const aliased = ALIASES[base];
		if (aliased) return aliased;
		if (isSupportedLocale(base)) return base;
	}
	return DEFAULT_LOCALE;
}
